import api from './api';
import type {
  OpsScorecard,
  HeatmapCell,
  RatingDistribution,
  NegativeFeedback,
  ProductPerformanceItem,
  GrowthData,
  OpsConfigData,
  OccupancyBreakdownRow,
  TimeSlotSummaryRow,
  InternalControlData,
} from '../types/ops';


interface DateRangeParams {
  from: string;
  to: string;
  excludeAtHome?: boolean;
}

export const opsApi = {
  async getScorecards(params: DateRangeParams): Promise<OpsScorecard> {
    const { data } = await api.get('/ops/scorecards', { params });
    return data;
  },

  async getCheckinHeatmap(params: DateRangeParams): Promise<HeatmapCell[]> {
    const { data } = await api.get('/ops/heatmap/checkins', { params });
    return data;
  },

  async getSessionHeatmap(params: Omit<DateRangeParams, 'excludeAtHome'>): Promise<HeatmapCell[]> {
    const { data } = await api.get('/ops/heatmap/sessions', { params });
    return data;
  },

  async getRatingDistribution(params: DateRangeParams): Promise<RatingDistribution[]> {
    const { data } = await api.get('/ops/ratings/distribution', { params });
    return data;
  },

  async getNegativeFeedback(params: DateRangeParams): Promise<NegativeFeedback[]> {
    const { data } = await api.get('/ops/ratings/negative', { params });
    return data;
  },

  async getProductPerformance(params: DateRangeParams): Promise<ProductPerformanceItem[]> {
    const { data } = await api.get('/ops/product-performance', { params });
    return data;
  },

  async getGrowth(params: DateRangeParams): Promise<GrowthData> {
    const { data } = await api.get('/ops/growth', { params });
    return data;
  },

  async getOccupancyBreakdown(params: DateRangeParams): Promise<OccupancyBreakdownRow[]> {
    const { data } = await api.get('/ops/occupancy-breakdown', { params });
    return data;
  },

  async getTimeSlotsSummary(): Promise<TimeSlotSummaryRow[]> {
    const { data } = await api.get('/ops/timeslots-summary');
    return data;
  },

  async getInternalControl(params: DateRangeParams): Promise<InternalControlData> {
    const { data } = await api.get('/ops/internal-control', { params });
    return data;
  },

  async getConfig(): Promise<OpsConfigData> {
    const { data } = await api.get('/ops/config');
    return data;
  },

  async saveConfig(config: OpsConfigData): Promise<OpsConfigData> {
    const { data } = await api.put('/ops/config', config);
    return data;
  },
};
